
import { gsap } from 'gsap';
//import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
//gsap.registerPlugin(ScrollToPlugin);
import { debounce as _debounce } from 'underscore';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import '@benmajor/jquery-touch-events';
import 'jquery-clickout';

export default class{

    constructor( options ) {
        this.defaults = {
        	$el:                   false,
            $trigger:              false,

            time_transition_on:    0.6,
            time_transition_off:   0.4,

            forceOpen:             false,

            interval_event_time:   10000,  

            global:                true

        }
        this.options = {};
		Object.assign(this.options, this.defaults, options);
		this.namespace 		= 	'video_window';
		this.$el 			= 	this.options.$el;
        this.$trigger       =   this.options.$trigger;
		this.main			=   this.options.main;
        this.interval_event =   false;

		if ( this.$el.length > 0 ){
			this.init();
		}
    }

    init(){
    	this.$html = $('html');
        this.$win  = $(window);

        // attach to the body!!!!
        if( ! this.$el.parent().is( 'body' ) ){
            $('body').append( this.$el );
        }

    	this.$close     = this.$el.find( 'a.win-close' );
        this.$scroll    = this.$el.find( '.scroll-content' );
        this.$content   = this.$el.find( '.window-content' );
        this.$popup     = this.$el.find( '.window' );

    	this.addEvents( true );

        if ( this.options.forceOpen ){
            this.forceOpen()
        }
	}

	//---------------------------------------- EVENTS ---------------------------------------//
	addEvents( b ){
		if ( b ){
    		if ( this.$html.hasClass( 'touch' ) ){
    			this.$close.on( 'tap', (e)=>this.open(false,e) );
    		}
    		else{
    			this.$close.on( 'click', (e)=>this.open(false,e) );
    		}
            //this.$el.find( '.window' ).on( 'clickout', (e)=>this.open(false,e) );              
            //this.$trigger.on( 'click', (e)=>this.triggerWindow(e) );
            //this.$trigger.addClass( 'no-barba' );
		}
		else{
    		if ( this.$html.hasClass( 'touch' ) ){
    			this.$close.off( 'tap', (e)=>this.open(false,e) );
    		}
    		else{
    			this.$close.off( 'click', (e)=>this.open(false,e) );
    		}
            //this.$trigger.off( 'click', (e)=>this.triggerWindow(e) );
            //this.$el.find( '.window' ).off( 'clickout', (e)=>this.open(false,e) );
		}
        this.debounceResize(b);
	}

    triggerWindow(e){
        e.preventDefault();
        let $a = $(e.currentTarget), 
            $template = $a.find( 'script' );

        if ( $template.length === 0 ){
            $template = $a.find( 'template' );
        }

        if ( $template.length > 0 ){
            this.addContent( true, $template.html() );
            this.open( true );
        }
        return false;
    }

    addContent( b, html ){
        if ( b ){
            this.$content.html( html );
            this.onResize();

            let $i = this.$content.find( 'iframe' );
            this.info = {
                title   : $i.length > 0 ? $i.attr( 'title' ) : '',
                src     : $i.length > 0 ? $i.attr( 'src' ) : ''
            }
        }
        else{
            this.$content.html( '' );
        }
    }

    debounceResize(b){
        if ( b ){
            // debounce resize
            this._debResize = _debounce( () => this.onResize(), 117 );
            this.$win.on( 'resize', this._debResize );
        }
        else{
            if ( this._debResize ){
                this._debResize.cancel();
                this.$win.off( 'resize', this._debResize );
            }        
        }
    }

    addClickOut(b){
        let $i = this.$el.find( 'iframe' );
        if ( $i.length > 0 ){
            if ( b ){
                $i.on( 'clickout', (e)=>this.open(false,e) );
            }
            else{
                $i.off( 'clickout', (e)=>this.open(false,e) );
            }
        }
    }

    onResize(){
        let $i = this.$el.find( 'iframe' ), w = Math.min( 1800, this.$win.width() ), h = Math.min( 1400, this.$win.height() ), iw, ih, p,
        margin = 80;
        if ( $i.length > 0 ){
            iw = parseInt( $i.attr('width') );
            ih = parseInt( $i.attr('height') );
            p = Math.min( w/iw, (h-2*margin)/ih );
            $i.css({
                width: Math.round(p*iw),
                height: Math.round(p*ih)
            })
        }
    }

    onComplete(b){
        if ( !b ){
            this.addClickOut( false );
            this.$el.removeClass( 'is-open' );
            this.addContent( false );
        }
        else{
            this.addClickOut( true );
        }
    }

    //---------------------------------------- GOOGLE EVENTS ---------------------------------------//

    activateGaEvent( b ){
        if ( b ){
            this.interval_event = setInterval( ()=>this.sendGaEvent(), this.options.interval_event_time );
        }
        else{
            clearInterval( this.interval_event );
        }
    }

    sendGaEvent(){
        this.options.main.setGAEvent( 'Video Play 10s Interval', 'interval', this.info.title, this.info.src );
    }


    //---------------------------------------- METHODS ---------------------------------------//
    open(b,e){

        if ( e ){
            e.preventDefault();
        }

        let t = gsap.timeline(), dy = 10;
    	if ( b ){
            this.$el.addClass( 'is-open' );
            this.$el.find( '.scroll-content' ).scrollTop(0);
            t.fromTo( this.$popup, { y: dy }, {y:0, ease:'power2.easeOut',duration: this.options.time_transition_on} );
			t.fromTo( this.$el, { opacity:0}, {opacity:1, ease:'power2.easeOut', duration: this.options.time_transition_on, onComplete: ()=>this.onComplete(b)}, "-=" + this.options.time_transition_on );
            disableBodyScroll( this.$scroll[0] );
    	}
    	else{
            t.fromTo( this.$popup, { y:0 }, {y: - dy, ease:'power2.easeOut',duration: this.options.time_transition_off} );
    		t.to( this.$el, {opacity:0, ease:'power2.easeOut', duration: this.options.time_transition_off, onComplete: ()=>this.onComplete(b) }, "-=" + this.options.time_transition_off );
            enableBodyScroll( this.$scroll[0] );
    	}

        this.activateGaEvent( b );
        if ( !b ){
            this.options.main.setGAEvent( 'Video Close', 'click', this.info.title, this.info.src );
        }

        return false
    }

    destroy(){
		if ( this.$el.length > 0 && this.$trigger.length > 0  && !this.options.global ){
            this.addContent( false );
    		this.addEvents( false );
            this.activateGaEvent( false );
            this.$el.remove()
    	}
    }

}


